export enum FeatureTourStepEnum {
  FIRST_USE = 'FIRST_USE',
  START = 'START',
  SEARCH_BAR = 'SEARCH_BAR',
  ADVANCED_SEARCH = 'ADVANCED_SEARCH',
  MASS_ACTIONS = 'MASS_ACTIONS',
}
